import styled from 'styled-components';

import { media } from 'utils/style';

import HelpContact from 'components/ModalFaqs/Sections/FaqsWithMarkup/HelpContact/container';

export default styled(HelpContact)`
  display: flex;

  width: 100%;
  padding-right: 24px;
  padding-left: 12px;
  justify-content: space-between;

  div {
    display: flex;
    flex-direction: column;
  }

  .label {
    font-size: 16px;
    color: var(--grey700);
    margin-bottom: 4px;
  }

  .payload {
    font-size: 24px;
    font-weight: 500;

    color: #263340;
    margin-bottom: 2rem;
  }

  ${media.lessThan('medium')`
      flex-direction: row;
      display: flex;
      justify-content: space-around;
      padding: 0;
  `}

  ${media.lessThan('extraSmall')`
  .payload {
    font-size: 14px;
    font-weight: 500;
  }

  .label {
    font-size: 12px;
    color: var(--grey700);
    margin-bottom: 4px;
  }

  `}
`;
